function BrandTagIcon({ className }: { className?: string }): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className={className}
    >
      <path
        d="M4.75 4.75H4.76M4.75 0.75H9.75C10.262 0.75 10.774 0.945 11.164 1.336L18.164 8.336C18.5389 8.71106 18.7496 9.21967 18.7496 9.75C18.7496 10.2803 18.5389 10.7889 18.164 11.164L11.164 18.164C10.7889 18.5389 10.2803 18.7496 9.75 18.7496C9.21967 18.7496 8.71106 18.5389 8.336 18.164L1.336 11.164C1.15 10.9785 1.00249 10.7581 0.901923 10.5155C0.801359 10.2728 0.74973 10.0127 0.750001 9.75V4.75C0.750001 3.68913 1.17143 2.67172 1.92157 1.92157C2.67172 1.17143 3.68913 0.75 4.75 0.75Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default BrandTagIcon;
